var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"storefront-image",class:_vm.styles.border,attrs:{"alt":"bodega storefront","height":_vm.styles.size,"width":_vm.styles.size,"src":_vm.wait(_vm.storeInfo, 'image')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }